<div [class.ui-chip-community]="license?.isCommunity"
     [class.ui-chip-red]="license?.isExpired"
     [class.ui-chip-orange]="license?.expiresSoon"
     [class.ui-chip-green]="license?.isRegistered &&
                            !license?.isExpired &&
                            !license?.expiresSoon"
     [class.ui-chip-condensed]="mode === 'condensed'"
     (click)="openExpirationModal()"
     class="ui-chip">
    <ng-container *ngIf="!license?.isRegistered; else registered">
        {{ (license?.isCommunity ? 'settings_license_community' : 'settings_license_unregistered') | translate }}
    </ng-container>
    <ng-template #registered>
        <ng-container *ngIf="license?.isExpired; else notExpired">
            <ng-container [ngSwitch]="mode">
                <ng-container *ngSwitchCase="'normal'">
                    {{ 'settings_license_expired_on' | translate }}:
                    <ng-container *ngTemplateOutlet="formattedDate"></ng-container>
                </ng-container>
                <ng-container *ngSwitchCase="'condensed'">
                    {{ 'settings_license_expired' | translate }}
                </ng-container>
            </ng-container>
        </ng-container>
        <ng-template #notExpired>
            {{ 'settings_license_licensed_until' | translate }}:
            <ng-container *ngTemplateOutlet="formattedDate"></ng-container>
        </ng-template>
    </ng-template>
</div>

<ng-template #formattedDate>
    <ui-dateformat #expirationDateFormat
                   [matTooltip]="expirationDateFormat.dataset['title']"
                   [date]="license?.expirationDate"
                   dateFormat="L"></ui-dateformat>
</ng-template>
